import React from "react";
import { OrganisationSettings, Spinner } from "@design-system";
import { UPDATE_SETTINGS } from "../../../graphql/mutation";
import { useMutation, useSettings } from "../../../hooks";
import { FIND_LATEST_SETTINGS_QUERY } from "../../../graphql/query";
import { useQuery } from "@apollo/client";
import { GET_CURRENCIES } from "~/graphql/query/currencies-query";

export const OrganisationSettingsContainer = () => {
  const { loading: loadingSettings, settings } = useSettings();

  const { data: currencies, loading } = useQuery(GET_CURRENCIES);

  const [updateSettings, { loading: loadingCreateSettings }] = useMutation(UPDATE_SETTINGS, {
    update(cache, { data }) {
      const updateSettings = data?.updateSettings;
      if (updateSettings) {
        cache.writeQuery({
          query: FIND_LATEST_SETTINGS_QUERY,
          data: {
            findLatestSettings: updateSettings,
          },
        });
      }
    },
  });

  if (loadingSettings) {
    return <Spinner show />;
  }

  return (
    <OrganisationSettings
      loading={loading || loadingCreateSettings}
      settings={settings}
      currencies={currencies?.currencies ?? []}
      onUpdate={async (formValues) => {
        await updateSettings({
          variables: {
            id: settings.id,
            data: {
              gpmDangerThreshold: { set: formValues.gpmDangerThreshold },
              gpmWarningThreshold: { set: formValues.gpmWarningThreshold ?? null },
              organisationPmsName: { set: formValues.organisationPmsName },
              currency: { connect: { id: formValues.currency } },
              administrationCharge: { set: formValues.administrationCharge },
              decimalTimeInput: { set: formValues.decimalTimeInput },
              autoCloseIntervalInDays: { set: formValues.autoCloseIntervalInDays },
              taxEnabled: { set: formValues.taxEnabled },
              ...(formValues.taxEnabled && {
                taxLabel: { set: formValues.taxLabel },
                taxLevelPercent: { set: formValues.taxLevelPercent },
                taxEnabledOptionDefault: { set: formValues.taxEnabledOptionDefault },
              }),
            },
          },
          context: {
            hasUpload: true,
          },
        });
      }}
    />
  );
};
